import { UserInfo, RoleFlags, RoleFlagOptions } from '../types';

export const userHasRequiredRole = (
  user?: UserInfo,
  allowedRoles?: RoleFlagOptions,
) => {
  if (!allowedRoles) {
    return true;
  }

  const flags = (Object.keys(allowedRoles) as Array<keyof RoleFlags>).filter(
    (key) => allowedRoles[key],
  );

  if (flags.length === 0) {
    return true;
  }

  if (!user) {
    return false;
  }

  return flags.some((key) => user[key]);
};
